import Layout from "./layout.js";

import "../styles.scss";

export default () => (
  <Layout>
    <div className="notice">
      Thanks!<br /><br/>Please check your email for a link to confirm your subscription.
    </div>
  </Layout>
);
